import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { MasterHeaderPage } from './master-header.page';
import { MenuOptionComponent } from './menu-option/menu-option.page';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageSwitcherModule } from '../../components/language-switcher/language-switcher.module';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [MasterHeaderPage, MenuOptionComponent],
  imports: [CommonModule, IonicModule, TranslateModule, FormsModule, LanguageSwitcherModule],
  exports: [MasterHeaderPage, MenuOptionComponent],
})
export class MasterHeaderModule {}
